import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProjectDetail from './components/ProjectDetail';
import Login from './components/Login';
import Header from './components/Header';
import AdminDashboard from './components/AdminDashboard';
import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import FAQ from './components/FAQ';
import Testimonials from './components/Testimonials';
import Benefits from './components/Benefits';
import PublicProjects from './components/PublicProjects';
import Phase2 from './components/Phase2';
import FuturisticHero from './components/FuturisticHero';
import FuturisticDashboard from './components/FuturisticDashboard';
import EnhancedHero from './components/EnhancedHero';
import SolanaSimulation from './components/SolanaSimulation';
import SolanaDemo from './components/SolanaDemo';
import WindPowerMonitoring from './components/WindPowerMonitoring';
// New main navigation pages
import Invest from './components/Invest';
import TrackImpact from './components/TrackImpact';
import Learn from './components/Learn';
import Support from './components/Support';
import { FirebaseAuthProvider, useFirebaseAuth } from './context/FirebaseAuthContext';
import { SimpleWalletProvider } from './context/SimpleWalletContext';
import './index.css';

function AppRoutes() {
  const { user, loading } = useFirebaseAuth();

  console.log('AppRoutes rendering - user:', user, 'loading:', loading);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading GreenOVA8...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Routes>
        {/* Main Navigation Pages */}
        <Route
          path="/"
          element={<Hero />}
        />
        <Route
          path="/home"
          element={<Hero />}
        />
        <Route
          path="/invest"
          element={<Invest />}
        />
        <Route
          path="/invest/solar"
          element={<Invest />}
        />
        <Route
          path="/invest/wind"
          element={<Invest />}
        />
        <Route
          path="/invest/hydro"
          element={<Invest />}
        />
        <Route
          path="/invest/community"
          element={<Invest />}
        />
        <Route
          path="/track-impact"
          element={<TrackImpact />}
        />
        <Route
          path="/learn"
          element={<Learn />}
        />
        <Route
          path="/support"
          element={<Support />}
        />

        {/* Legacy/Additional Pages */}
        <Route
          path="/hero-old"
          element={<Hero />}
        />
        <Route
          path="/enhanced"
          element={<EnhancedHero />}
        />
        <Route
          path="/futuristic"
          element={<FuturisticHero />}
        />
        <Route
          path="/login"
          element={user ? <Navigate to="/" /> : <Login />}
        />
        <Route
          path="/futuristic-dashboard"
          element={<FuturisticDashboard />}
        />
        <Route
          path="/projects"
          element={<Navigate to="/invest" replace />}
        />
        <Route
          path="/projects/:id"
          element={<ProjectDetail />}
        />
        <Route
          path="/admin"
          element={<AdminDashboard />}
        />
        <Route
          path="/about"
          element={<About />}
        />
        <Route
          path="/how-it-works"
          element={<HowItWorks />}
        />
        <Route
          path="/features"
          element={<PublicProjects />}
        />
        <Route
          path="/benefits"
          element={<Benefits />}
        />
        <Route
          path="/testimonials"
          element={<Testimonials />}
        />
        <Route
          path="/faq"
          element={<FAQ />}
        />
        <Route
          path="/phase2"
          element={<Phase2 />}
        />
        <Route
          path="/solana-simulation"
          element={<SolanaSimulation />}
        />
        <Route
          path="/solana-demo"
          element={<SolanaDemo />}
        />
        <Route
          path="/wind-monitoring"
          element={<WindPowerMonitoring />}
        />
      </Routes>
    </div>
  );
}

function App() {
  console.log('🏁 App component rendering');

  return (
    <Router>
      <FirebaseAuthProvider>
        <SimpleWalletProvider>
          <AppRoutes />
        </SimpleWalletProvider>
      </FirebaseAuthProvider>
    </Router>
  );
}

export default App;
